module.exports = __webpack_public_path__ + "media/honey-icons/icon-coffee-97108768.svg";